export class PromiseQueue {
    private queue: {
        fn: Function,
        resolve: (result:any) => void,
        reject: (error:any) => void
    }[]
    private workingOnPromise: boolean

    constructor() {
        this.queue = []
        this.workingOnPromise = false
    }

    public enqueue(fn : Function) {
        return new Promise((resolve,reject) => {
            this.queue.push({
                fn,
                resolve,
                reject
            })

            this.dequeue()
        })
    }

    public dequeue() {
        if (this.workingOnPromise) {
            return false
        }

        const item = this.queue.shift()

        if (item == null) {
            return false
        }

        try {
            this.workingOnPromise = true

            item.fn()
                .then(result => {
                    this.workingOnPromise = false
                    item.resolve(result)
                    this.dequeue()
                })
                .catch(err => {
                    this.workingOnPromise = false
                    item.reject(err)
                    this.dequeue()
                })

        } catch (err) {
            this.workingOnPromise = false
            item.reject(err)
            this.dequeue()
        }

        return true
    }

}